
<template>
	<div class="result-list">
	 	<ul>
	        <result-item v-for="result in results" :key="result.id" v-bind:result='result'></result-item>
	 	</ul>
		
	</div>
</template>

<script>
export default {
    name: 'Musiclibraryl5Sample',
    props: ['results'],

    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>
